import { createAction, props } from '@ngrx/store';
import { ShippingBacklogItem } from '../../model/shipping-backlog.model';

export const saveSelctedItems = createAction(
  '[ShippingBacklog] Save Selected Items',
  props<{ selectedItems: ShippingBacklogItem[] }>()
);